import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Voltide';
const BASE_URL = 'https://voltide.energy';
const DEFAULT_DESC = 'Battery Energy Storage Systems (BESS) for rent or purchase. Replace diesel generators with clean, silent, cost-effective battery power.';
const DEFAULT_IMAGE = `${BASE_URL}/images/voltide-logo.svg`;

export function SEO({ title, description, path = '/', image, type = 'website', schema }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Clean Energy Storage Solutions`;
  const desc = description || DEFAULT_DESC;
  const url = `${BASE_URL}${path}`;
  const img = image || DEFAULT_IMAGE;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />

      {/* Schema.org JSON-LD */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Voltide",
  "url": BASE_URL,
  "logo": `${BASE_URL}/images/voltide-logo.svg`,
  "description": DEFAULT_DESC,
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Bangalore",
    "addressCountry": "IN"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "sales",
    "email": "hello@voltide.energy"
  }
};
